import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class ControlCenterIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 24 24" >
            <g fill="currentColor">
                <path d="M12,24c-0.12,0-0.241-0.023-0.354-0.069C5.71,21.508,1.875,15.8,1.875,9.389V4.752c0-0.379,0.228-0.721,0.578-0.866
                    l9.188-3.815c0.23-0.095,0.489-0.095,0.719,0l9.187,3.815c0.35,0.145,0.579,0.487,0.579,0.866v4.637
                    c0,6.411-3.835,12.12-9.771,14.542C12.241,23.977,12.12,24,12,24z M3.75,5.378v4.011c0,5.517,3.225,10.444,8.25,12.656
                    c5.024-2.212,8.25-7.138,8.25-12.656V5.378L12,1.952L3.75,5.378z"/>
                <path d="M10.964,14.812c-0.24,0-0.48-0.091-0.663-0.274l-2.62-2.621c-0.366-0.366-0.366-0.959,0-1.326
                    c0.366-0.366,0.959-0.366,1.326,0l1.957,1.957l4.029-4.03c0.366-0.366,0.961-0.366,1.327,0c0.365,0.366,0.365,0.959,0,1.326
                    l-4.693,4.693C11.443,14.722,11.204,14.812,10.964,14.812z"/>
            </g>
        </SvgIcon>;
    }
}
